/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.updateStaticErrorLinks = full_url => $('a').each(function() {
  const href = $(this).attr('href');
  if (!href.startsWith('http')) { return $(this).attr('href', full_url + href); }
});
